import { QuestionPlanIsUnchangeable as Question } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/is-unchangeable";

import { usePlanIsUnchangeable } from "./hooks";

export const QuestionPlanIsUnchangeable = () => {
	const { isUnchangeable, onSetIsUnchangeable } = usePlanIsUnchangeable();

	return <Question isUnchangeable={isUnchangeable} onSetIsUnchangeable={onSetIsUnchangeable} />;
};

QuestionPlanIsUnchangeable.displayName = "QuestionPlanIsUnchangeable";
